import { translateObject, translateObjectInverse } from '@huggg/bar-staff';
import dayjs from 'dayjs';
import { prop } from 'ramda';
import { urls } from '../config';
import { cursorPaginatedResponseMap, invoiceMap } from '../translationMaps';
import getCursorPaginationParams from '../utils/getCursorPaginationParams';
import withAxios from '../utils/with-axios';
var DEFAULT_PER_PAGE = 20;
function formatInvoice(data) {
  var invoice = data.data;
  var translated = translateObject(invoiceMap, invoice);
  translated.until = dayjs(translated.until).subtract(1, 'days').toISOString();
  return translated;
}
function formatAllResponse(data) {
  var translatedPagination = translateObject(cursorPaginatedResponseMap, data);
  if (translatedPagination.data.length) {
    translatedPagination.data = translatedPagination.data.map(function (item) {
      return formatInvoice({
        data: item
      });
    });
  }
  return translatedPagination;
}

/**
 * Fetch all invoices for a given team ID.
 *
 * @param {Object} $axios [$axios=axios] Axios instance.
 * @param {String} userId
 * @param {Object[]} options
 * @param {Number} [options[].usePagination=true] Whether to use pagination
 * @param {Number} [options[].limit=DEFAULT_PER_PAGE]
 *     How many items to  display per page
 * @param {String} [options[].next] Cursor to paginate forwards from
 * @param {String} [options[].previous] Cursor to paginate backwards from
 * @returns {Promise} Unresolved Promise from the API.
 */
function listByTeamId($axios, teamId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!teamId) {
    throw new Error('Prop `teamId` is required in `invoices.listByTeamId`');
  }
  var defaultParams = {
    use_pagination: true,
    limit: DEFAULT_PER_PAGE
  };
  var params = getCursorPaginationParams(options, defaultParams);
  return $axios.get(urls.apiV2("/teams/".concat(teamId, "/invoices")), {
    params: params
  }).then(prop('data')).then(formatAllResponse);
}

/**
 * Fetch a singular invoice by ID
 *
 * @param {Object} $axios [$axios=axios] Axios instance.
 * @param {String} id
 * @returns {Promise} Unresolved Promise from the API.
 */
function single($axios, id) {
  if (!id) {
    throw new Error('Prop `id` is required in `invoices.single`');
  }
  return $axios.get(urls.apiV2("/invoices/".concat(id))).then(prop('data')).then(formatInvoice);
}

/**
 * Updates notes for a invoice
 * @param {Object} [$axios=axios] Axios instance.
 * @param {String} id Invoice ID to update
 * @param {Object} data Data object to update the invoice
 * @returns {Promise} Unresolved Promise from the API.
 */
function update($axios, id, data) {
  var formatted = translateObjectInverse(invoiceMap, data);
  return $axios.patch(urls.apiV2("/invoices/".concat(id)), formatted).then(formatInvoice);
}
export default {
  listByTeamId: withAxios(listByTeamId),
  single: withAxios(single),
  update: withAxios(update)
};